/**
 * StatsBar Component
 * ==================
 * Horizontal stats strip
 * ALL content from Blueprint - NO hardcoded text
 * 
 * Expected config format (ui.home.stats):
 * [
 *   { label: "Materiali", value: "243+" },
 *   { label: "Progetti", value: "1.2K+" }
 * ]
 */

import React from 'react';
import { useBlueprint, BlueprintSection } from '../../context/BlueprintContext';

const StatsBar = () => {
  const { homepage } = useBlueprint();
  
  // Stats can be array directly or object with items
  let stats = homepage?.stats || [];
  if (!Array.isArray(stats)) {
    stats = stats.items || [];
  }
  
  // If no stats, don't render
  if (!stats.length) {
    return null;
  }
  
  return (
    <BlueprintSection name="stats">
      <section className="bg-[#E8E4DE] border-t border-b border-[#D8D4CE]">
        <div className="sr-container">
          <div className={`grid grid-cols-2 lg:grid-cols-${Math.min(stats.length, 4)}`}>
            {stats.map((stat, i) => (
              <div
                key={i}
                className={`flex items-center justify-center gap-3 py-7 px-6 ${
                  i < stats.length - 1 ? 'border-r border-[#D0CCC6]' : ''
                } ${i < 2 && stats.length > 2 ? 'border-b lg:border-b-0 border-[#D0CCC6]' : ''}`}
              >
                <div className="text-center">
                  <div className="text-[28px] font-bold text-[var(--gold)] mb-1">
                    {stat.value}
                  </div>
                  <div className="text-[12px] text-[#555] font-medium uppercase tracking-wider">
                    {stat.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </BlueprintSection>
  );
};

export default StatsBar;
